import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-uploader__uploader-container__uploader pa-5 d-flex align-center flex xs12" }
const _hoisted_2 = { class: "pb-4 title app-uploader__uploader-container__uploader__preview-instructions" }
const _hoisted_3 = { class: "font-weight-bold body-1 mt-3 text-grey" }
const _hoisted_4 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'app-uploader--disabled': _ctx.disabled, 'app-uploader': true })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["app-uploader__uploader-container d-flex align-center justify-center flex xs12", { 'app-uploader__uploader-container--highlight': _ctx.isDragActive }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-h5 font-weight-bold" }, "Upload a sheet", -1))
          ]),
          _renderSlot(_ctx.$slots, "icon", { class: "my-4" }, () => [
            _createVNode(_component_v_icon, { large: "" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" fas fa-file-upload ", -1)
              ]))]),
              _: 1
            })
          ]),
          _renderSlot(_ctx.$slots, "description", {}, () => [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "font-weight-bold" }, "Drag and drop to upload", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "font-weight-bold" }, [
              _createTextVNode(" or "),
              _createElementVNode("span", { class: "app-uploader__uploader-container__uploader__click-button" }, " browse to choose a file ")
            ], -1))
          ]),
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "caption pt-3" }, [
              _createTextVNode("Please upload a "),
              _createElementVNode("b", null, ".csv"),
              _createTextVNode(" file only.")
            ], -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1))
        ], 512), [
          [_vShow, !_ctx.isFileSelected]
        ]),
        (_ctx.isFileSelected)
          ? _renderSlot(_ctx.$slots, "preview-instructions", {}, () => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_icon, { large: "" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" fas fa-clipboard-check ", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "my-2 text-h6" }, "File is ready to be uploaded", -1)),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.fileName), 1)
              ])
            ], undefined, 0)
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["app-uploader__overlay-content", { 'app-uploader__overlay-content--is-active': _ctx.isDragActive }])
        }, [
          _renderSlot(_ctx.$slots, "active-overlay", {}, () => [
            _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Drop file to upload", -1))
          ])
        ], 2), [
          [_vShow, _ctx.isDragActive]
        ]),
        _createElementVNode("div", {
          class: "app-uploader__overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
          onDragover: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
          onDrop: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onUpload($event, 'drop')), ["prevent"])),
          onDragleave: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"]))
        }, null, 32)
      ]),
      _createElementVNode("input", {
        ref: "fileUpload",
        type: "file",
        style: {"display":"none"},
        accept: _ctx.fileType ? _ctx.fileType : '',
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onUpload($event, 'browse')))
      }, null, 40, _hoisted_4)
    ], 2)
  ], 2))
}